// src/utils/geoUtils.js

/**
 * Round a number up to the nearest multiple of 10.
 */
export function roundToNearestTen(value) {
  return Math.ceil(parseFloat(value) / 10) * 10;
}

/**
 * Calculate distance between two coordinates using Haversine formula.
 * @param {[number, number]} startCoordinates [lat, lon]
 * @param {[number, number]} endCoordinates [lat, lon]
 * @returns {number} distance in kilometers
 */
export function distanceInKm([startLat, startLon], [endLat, endLon]) {
  const EARTH_RADIUS_KM = 6371;

  const toRadians = (degrees) => (degrees * Math.PI) / 180;

  const deltaLat = toRadians(endLat - startLat);
  const deltaLon = toRadians(endLon - startLon);

  const startLatRadians = toRadians(startLat);
  const endLatRadians = toRadians(endLat);

  const haversineValue =
    Math.sin(deltaLat / 2) ** 2 +
    Math.cos(startLatRadians) *
      Math.cos(endLatRadians) *
      Math.sin(deltaLon / 2) ** 2;

  const angularDistance =
    2 *
    Math.atan2(
      Math.sqrt(haversineValue),
      Math.sqrt(1 - haversineValue)
    );

  return EARTH_RADIUS_KM * angularDistance;
}

/**
 * Filter companies within a radius (km) of a user's coordinates.
 */
export function filterPlacesWithinRadius(companyList, userCoordinates, radiusKm) {
  if (!userCoordinates || !Array.isArray(companyList)) return [];

  return companyList.filter((company) => {
    const { lat: companyLat, lon: companyLon } = company;
    if (companyLat == null || companyLon == null) return false;

    const distanceToCompany = distanceInKm(userCoordinates, [
      companyLat,
      companyLon,
    ]);
    return distanceToCompany <= radiusKm;
  });
}
